module.exports = __webpack_public_path__ + "static/media/sona-buvelle-icon.0e665a26.png";